<template>
  <div id="app">
    <router-view />
    <!-- dev1 -->
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
*{
    margin: 0;padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue